/**
 * Enlaces de los correos de acceso (recuperar contraseña e invitación), 09/10/2026.
 *
 * Las plantillas de producción construyen el botón como `{{ .ConfirmationURL }}/auth-callback.html`:
 * a la dirección de vuelta (`redirect_to`) le añaden `/auth-callback.html`. Si la app pide el
 * correo sin decir a dónde volver, Supabase usa la cabecera Referer del navegador
 * (la dirección de la app con barra final, p. ej. `https://crm.nevoraconsulting.com/`) y el enlace acaba en
 * `//auth-callback.html`: en un navegador que ya ha usado el CRM, el service worker servía la
 * app en vez de esa página y se quedaba en «Iniciar sesión». Por eso la app pide siempre el
 * correo con la dirección de la app SIN barra final.
 */
export const urlDeVuelta = (href: string): string =>
  new URL(".", href).href.replace(/\/+$/, "");

/** Valor de `?enlace=` en «He olvidado mi contraseña» cuando el enlace ya no sirve. */
export const ENLACE_NO_VALIDO = "no-valido";
